import React from 'react';
import PropTypes from 'prop-types';

const Legend = ({ children, required, ...rest }) => <legend className="c-form__legend" {...rest}>
    {children}
    {required && <abbr className="c-form__required">*</abbr>}
  </legend>

export default Legend;

Legend.propTypes = {
  children: PropTypes.node,
  required: PropTypes.bool,
};
Legend.defaultProps = {
  children: null,
  required: false,
};
